import React from "react";
import { useTheme } from "styled-components";
import VideoPlayerButtonComponent from "../../VideoPlayerButton";

const PurchaseButton = ({ showPurchaseCTA, altText, openPurchaseModal, spinnerToggle }) => {
  const theme = useTheme();
  if (!showPurchaseCTA) {
    return null;
  }

  return (
    <VideoPlayerButtonComponent
      src={process.env.PUBLIC_URL + "/images/order.svg"}
      alt={altText}
      onClickHandler={openPurchaseModal}
      disabled={spinnerToggle}
      tooltipDirection="top"
      $hoverBackgroundColor={theme.colours.mineShaftGray}
    />
  );
};

export default PurchaseButton;
